import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isAuthenticated: false,
  isInitialized: false,
  menus: [],
  user: {}
};

let slice = createSlice({
  name: 'permissionSlice',
  initialState,
  reducers: {
    initialize(state, action) {
      state = Object.assign(state, action.payload);
    },
    authenticate(state, action) {
      console.log('dispatch');
      state = Object.assign(state, action.payload);
    },
    menus(state, action) {
      state = Object.assign(state, action.payload);
    }
  }
});
export const initialize = (isInitialized) => (dispatch) => {
  dispatch(slice.actions.initialize({ isInitialized }));
};
export const authenticate = (payload) => (dispatch) => {
  console.warn(payload);
  dispatch(slice.actions.authenticate(payload));
};
export const menu = (menus) => (dispatch) => {
  dispatch(slice.actions.menus(menus));
};
export const { reducer } = slice;
export default slice;
